import React from 'react'
import Param from '../store/param';
import FormSetup from './formSetup';
import FormAlign from './formAlign';
import FormBaseshape from './formBaseshape';
import FormMarking from './formMarking';
import FormCompress from './formCompress';
import FormModify from './formModify';
import FormTrim from './formTrim';
import FormThick from './formThick';
import FormOutput from './formOutput';

/**
 * Renders a form based on the active step stored in the Param store.
 * @returns {JSX.Element|string} The form component to render or 'Unknown step' if the active step is not recognized.
 */
const FormTest = () => {
  const activeStep = Param.Get('activeStep');

  switch (activeStep) {
    case 0:
      return <FormSetup/>;
    case 1:
      return <FormAlign/>;
    case 2:
      return <FormMarking/>;
    case 4:
      return <FormCompress/>;
    case 3:
      return <FormModify/>;
    case 5:
      return <FormTrim/>;
    case 6:
      return <FormThick/>;
    case 7:
      return <FormOutput/>;
    default:
      return 'Unknown step';
  }
}

export default FormTest
